import React from 'react';
import styles from './style.module.scss';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Grid,
} from '@material-ui/core';
import { InventoryRequestHeader, PageItems, AcceptedRequestHeader } from './constant';
import { ProductLoader } from '../../components/Loader/skeletonLoader';
import { CapitalizeFirstLetter } from '../../utils/validation';
import {convertDate, capitalizeOnlyFirstLetter} from "../../utils/commonFunctions";

const InventoryRequestData = (props) => {
    const tableHeader = props.copySelectedFilters.requestStatus === 'ACCEPTED' ? AcceptedRequestHeader : InventoryRequestHeader;

    //function to fetch table row data
    const getRowData = (column, value, item, index) => {
        if (column === 'status') {
            return <span>{value === 'INSTANT_LIVE' ? 'Instant Live' : value && CapitalizeFirstLetter(value.toLowerCase())}</span>
        }
        else if (column === 'requestedDate') {
            return convertDate(value);
        }
        else if(column === 'category') {
            return value ? capitalizeOnlyFirstLetter(value) : value;
        }
        else if (column === 'brand') {
            return  value ? capitalizeOnlyFirstLetter(value) : value
        }
        else if (column === 'requestedModel') {
            return  value ? capitalizeOnlyFirstLetter(value) : value
        }
        else if (column === 'acceptedModel') {
            return  value ? capitalizeOnlyFirstLetter(value.trim()) : value
        }
        return value;
    }

    return <React.Fragment >
        <div className={styles.orderWrapper}>
            {props.copySelectedFilters.requestStatus != null &&
                <Chip
                    label={
                        props.copySelectedFilters.requestStatus === 'INSTANT_LIVE' ?
                            'Instant Live' :
                            CapitalizeFirstLetter(props.copySelectedFilters.requestStatus.toLowerCase())
                    }
                    onDelete={() => props.handleDelete(props.copySelectedFilters.requestStatus, 'requestStatus')}
                    className={`mb-1 mr-1 ${styles.chip}`}
                />}
        </div>
        <div className={styles.tableConatiner}>
            {
                props.pageLoader ?
                    <Paper className={styles.loaderWrapper}>
                        <div id={styles.headerLoader}>
                        </div>
                        <div className="pl-4 pr-4">
                            <ProductLoader />
                        </div>
                    </Paper>
                    :
                    <Paper>
                        <TableContainer className={styles.parentWrapper}>
                            <Table stickyHeader aria-label="sticky table"  >
                                <TableHead>
                                    <TableRow >
                                        {tableHeader.map((column, index) => (
                                            <TableCell
                                                className={styles.tableBorder}
                                                key={index}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    {props.inventoryData && props.inventoryData.length > 0 && props.inventoryData.map((order, index) => {
                                        return (
                                            <TableRow key={index} hover key={index}>
                                                {tableHeader.map((header) => {
                                                    const value = order[header.id];
                                                    return (
                                                        <TableCell key={header.id} align={header.align} className={styles.tableBorder}>
                                                            {getRowData(header.id, value, order, index)}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                    {props.inventoryData && props.inventoryData.length === 0 &&
                                        <tr>
                                            <td colSpan="7">
                                                <div className="d-flex justify-content-center p-5 text-muted">
                                                    No data to display
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="pl-3 pr-3 p-2">
                        <Grid container justify='space-between' >
                            <Grid item>
                            <div className="text-muted">
                                Showing {props.inventoryReqObj.page === 1 ? props.inventoryReqObj.page : props.inventoryReqObj.size * (props.inventoryReqObj.page - 1)} - 
                                {props.inventoryReqObj.page === 1 ? props.inventoryReqObj.size :  (props.inventoryData && props.inventoryData.length) === props.inventoryReqObj.size ? props.inventoryReqObj.size * props.inventoryReqObj.page : ((props.inventoryReqObj.size * props.inventoryReqObj.page) - (props.inventoryReqObj.size - props.inventoryData.length))} of {props.totalInventory} entries
                                <span className={styles.divider}></span>
                                <span>
                                    Rows per page
                                    <select
                                        className={styles.selectPadding}
                                        value={props.inventoryReqObj.size}
                                        onChange={(e) => props.setItemsPerPage(e.target.value)}>
                                        {
                                            PageItems.map((page, index) => {
                                                return <option key={index} value={page}>{page}</option>
                                            })
                                        }
                                    </select>
                                </span>
                            </div>
                            </Grid>
                            <Grid item>
                            <div className="">
                                <nav aria-label="..." style={{ top: 10 }}>
                                    <ul className="pagination mb-0">
                                        <li onClick={() => props.inventoryReqObj.page > 1 && props.totalPageCount != 0 ? props.handlePageChange('prev') : null} className={`page-item ${props.inventoryReqObj.page === 1 || props.totalPageCount === 0 ? "disabled" : null} `}>
                                            <button className={`${props.inventoryReqObj.page === 1 || props.totalPageCount === 0 ? styles.disablePage : null} page-link ${styles.pageLink}`} tabIndex="-1">
                                                Previous
                                            </button>
                                        </li>
                                        <li>
                                            <button className={`page-link ${styles.page}`} style={{ pointerEvents: 'none' }}>
                                                {props.inventoryReqObj.page}
                                            </button>
                                        </li>
                                        <li onClick={() => props.totalPageCount != props.inventoryReqObj.page && props.totalPageCount != 0 ? props.handlePageChange('Next') : ''} className={`page-item ${props.totalPageCount == props.inventoryReqObj.page || props.totalPageCount === 0 ? "disabled" : null} `}>
                                            <button className={`${props.totalPageCount == props.inventoryReqObj.page || props.totalPageCount === 0 ? styles.disablePage : null} page-link ${styles.pageLink}`} >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>

                            </div>
                            </Grid>
                            </Grid>
                        </div>
                    </Paper>
            }
        </div>
    </React.Fragment>
}

const InventoryRequest = React.memo(InventoryRequestData);
export default InventoryRequest;
